import { createContext } from 'react';

const JsonFormContext = createContext({
  getPropertyValue: null,
});

export default JsonFormContext;
